import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { App } from './App';
import './index.scss';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(TonConnectUIProvider, { manifestUrl: "https://gist.github.com/anovic123/0212525dbb166a0b88b5714010a87e57.txt", children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }));
